import { customAxios, customPatchAxios } from "./customAxios";

/**
 * 유지보수 목록
 * @param {*} query 
 * @returns 
 */
export const getMaintenanceTasksByQuery = async(query)=>{
  const res = await customAxios.get('/api/maintenanceTasks', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 목록(queryString)
 * @param {*} query 
 * @returns 
 */
export const getMaintenanceTasksByQueryString = async(query)=>{
    const res = await customAxios.get('/api/maintenanceTasks'+query);
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/**
 * 유지보수 Excel목록(queryString)
 * @param {*} query 
 * @returns 
 */
export const getMaintenanceTasksExcelByQueryString = async(query)=>{
  const res = await customAxios.get('/api/maintenanceTasks/excel', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 상태별 건수
 * @param {*} query 
 * @returns 
 */
export const getMaintenanceTasksCountGroupStatusByMntTypeByQuery = async()=>{
  const res = await customAxios.get('/api/maintenanceTasks/:countGroupByStatus');
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 상태별 건수(검색)
 * @param {*} query 
 * @returns 
 */
export const getMaintenanceTasksCountGroupStatusByMntTypeByQueryAndSearchString = async(query)=>{
  const res = await customAxios.get('/api/maintenanceTasks/:countGroupByStatus2'+query);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 상세
 * @param {*} id 
 * @returns 
 */
export const getMaintenanceTasksById = async(id)=>{
  const res = await customAxios.get('/api/maintenanceTasks/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수 삭제
 * @param {*} body 
 */
export const deleteMaintenanceTasks = async(param)=>{
  //console.log(param);
  const res = await customAxios.delete('/api/maintenanceTasks/'+param);
  console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}


/**
 * 월별 유지보수 건수
 * @param {*} query 
 * @returns 
 */
export const getMaintenanceTasksCountAllMonthlyGroupByMntTypeByQuery = async(query)=>{
    const res = await customAxios.get('/api/maintenanceTasks/countAllMonthlyGroupByMntType', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/**
 * 월별 고장건수 추이
 * @param {*} query 
 * @returns 
 */
export const getMaintenanceTasksCountMonthlyGroupByMntTypeByQuery = async(query)=>{
  const res = await customAxios.get('/api/maintenanceTasks/countMonthlyGroupByMntType', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 품목별 유지보수 비율
 * @param {*} query 
 * @returns 
 */
export const getMaintenanceTasksCountMntTypeGroupByEquipmentPartByQuery = async(query)=>{
  const res = await customAxios.get('/api/maintenanceTasks/countMntTypeGroupByEquipmentPart',{params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/**
 * 유지보수 확인
 * @param {*} id 
 * @param {*} body 
 */
export const patchMaintenanceTasksConfirm = async(id, body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/maintenanceTasks/'+id+':confirm',body);
}

/**
 * 성능점검결과보고서 목록
 * @param {*} query 
 * @returns 
 */
export const getMaintenanceCheckupResultsByQuery = async(query)=>{
    const res = await customAxios.get('/api/maintenanceCheckupResults', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}


/**
 * 성능점검결과보고서 목록
 * @param {*} query 
 * @returns 
 */
export const getMaintenanceCheckupResultsByQueryString = async(query)=>{
  const res = await customAxios.get('/api/maintenanceCheckupResults'+query);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}


/**
 * 성능점검결과보고서 작성시 상세 항목정보
 * @param {*} query 
 * @returns 
 */
export const getMaintenanceCheckupResultsById = async(id)=>{
    const res = await customAxios.get('/api/maintenanceCheckupResults/'+id);
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/**
 * 점검표 등록
 * @param {*} body 
 */
export const postMaintenanceCheckupResults = async(body)=>{
//console.log(body);
await customAxios.post('/api/maintenanceCheckupResults',body);
}

/**
 * 점검표 수정
 * @param {*} body 
 */
export const patchMaintenanceCheckupResults = async(body)=>{
//console.log(body);
await customPatchAxios.patch('/api/maintenanceCheckupResults/'+body.id, body);
}


/**
 * 점검표 삭제
 * @param {*} body 
 */
export const deleteMaintenanceCheckupResults = async(id)=>{
  //console.log(body);
  await customAxios.delete('/api/maintenanceCheckupResults/'+id);
}
  



/**
 * 성능점검결과보고서 목록
 * @param {*} query 
 * @returns 
 */
export const getPerformanceCheckupResultsByQuery = async(query)=>{
  const res = await customAxios.get('/api/performanceCheckupResults', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 성능점검결과보고서 목록
 * @param {*} query 
 * @returns 
 */
export const getPerformanceCheckupResultsByQueryString = async(query)=>{
  const res = await customAxios.get('/api/performanceCheckupResults'+query);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}



/**
 * 성능점검결과보고서 삭제
 * @param {*} query 
 * @returns 
 */
export const deletePerformanceCheckupResults = async(id)=>{
  await customAxios.delete('/api/performanceCheckupResults/'+id);
}